/* I'M GOODIES — Meu Goodie
   Ritual, calendário e pote: cálculo local (data do pedido + dias até a chegada (padrão 5) + dias × doses).
   Não usa API nem banco — só os data-* vindos do Liquid (pedidos Shopify). */
(function () {
  'use strict';

  var raiz = document.querySelector('.mg');
  if (!raiz) return;

  var DOSES_DIA = Number(raiz.getAttribute('data-doses-dia')) || 2;
  var semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var totalGummies = Number(raiz.getAttribute('data-total-gummies')) || Number(raiz.getAttribute('data-por-pote')) || 0;
  var inicioContagem = (raiz.getAttribute('data-inicio-contagem') || '').trim();
  var poteAtivo = raiz.getAttribute('data-pote-ativo') === 'true';
  var temPedido = raiz.getAttribute('data-tem-pedido') === 'true';

  function pad(n) { return String(n).padStart(2, '0'); }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function hojeIso() { return iso(new Date()); }
  function diasRitualDesdeInicio() {
    if (!inicioContagem || !/^\d{4}-\d{2}-\d{2}$/.test(inicioContagem)) return 0;
    var inicio = new Date(inicioContagem + 'T12:00:00');
    var hoje = new Date();
    hoje.setHours(12, 0, 0, 0);
    if (hoje < inicio) return 0;
    return Math.floor((hoje - inicio) / 86400000) + 1;
  }

  function ritualCompletoNoDia(diaStr) {
    if (!poteAtivo || !inicioContagem) return false;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(diaStr)) return false;
    return diaStr >= inicioContagem && diaStr <= hojeIso();
  }

  function metricasPote() {
    if (!poteAtivo || totalGummies <= 0) {
      return { consumidas: 0, restantes: totalGummies, diasRestantes: totalGummies ? Math.floor(totalGummies / DOSES_DIA) : 0 };
    }
    var dias = diasRitualDesdeInicio();
    var consumidas = Math.min(totalGummies, dias * DOSES_DIA);
    var restantes = Math.max(0, totalGummies - consumidas);
    return {
      consumidas: consumidas,
      restantes: restantes,
      diasRestantes: Math.floor(restantes / DOSES_DIA),
    };
  }

  /* saudação */
  var h = new Date().getHours();
  var per = document.getElementById('mg-periodo');
  if (per) per.textContent = h < 12 ? 'Bom dia' : (h < 18 ? 'Boa tarde' : 'Boa noite');
  var dt = document.getElementById('mg-data-hoje');
  if (dt) dt.textContent = new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });

  /* ritual */
  var FRASE_COMPLETA = 'Ritual completo. 3g fechados hoje.';
  var FRASE_AGUARDE_PEDIDO = 'Depois do seu primeiro pedido, o ritual preenche sozinho, dia a dia.';
  var FRASE_AGUARDE_ENTREGA = 'Seu ritual começa assim que seu pote chegar. Estamos quase lá.';
  var FRASE_ANTES = 'Seu ritual começa assim que seu pote chegar.';
  var botoes = raiz.querySelectorAll('.mg-gummy-btn');
  var avisoBloqueado = document.getElementById('mg-ritual-bloqueado');

  function pintarRitual() {
    var hoje = hojeIso();
    var completo = ritualCompletoNoDia(hoje);
    botoes.forEach(function (b) {
      b.setAttribute('aria-pressed', String(completo));
    });
    if (avisoBloqueado) avisoBloqueado.hidden = poteAtivo;
    var est = document.getElementById('mg-estado-ritual');
    if (!est) return;
    if (!temPedido) {
      est.textContent = FRASE_AGUARDE_PEDIDO;
      return;
    }
    if (!poteAtivo) {
      est.textContent = FRASE_AGUARDE_ENTREGA;
      return;
    }
    if (hoje < inicioContagem) {
      est.textContent = FRASE_ANTES;
      return;
    }
    est.textContent = completo ? FRASE_COMPLETA : FRASE_ANTES;
  }

  function pintarCalendario() {
    var lista = document.getElementById('mg-calendario');
    if (!lista) return;
    var agora = new Date(), ano = agora.getFullYear(), mes = agora.getMonth();
    var totalDias = new Date(ano, mes + 1, 0).getDate(), html = '', com = 0;
    for (var d = 1; d <= totalDias; d++) {
      var diaStr = ano + '-' + pad(mes + 1) + '-' + pad(d);
      var cheio = ritualCompletoNoDia(diaStr);
      if (cheio) com++;
      var cls = 'mg-dia' + (cheio ? ' mg-dia--cheio' : '') + (d === agora.getDate() ? ' mg-dia--hoje' : '');
      var rot = cheio ? 'dose completa' : 'sem ritual';
      html += '<li><span class="' + cls + '" title="Dia ' + d + ': ' + rot + '"><span aria-hidden="true">' + d +
              '</span><span class="mg-sr">Dia ' + d + ', ' + rot + '</span></span></li>';
    }
    lista.innerHTML = html;
    var c = document.getElementById('mg-dias-com');
    if (c) c.textContent = String(com);
  }

  function pintarPote() {
    var box = document.getElementById('mg-pote-dados');
    if (!box) return;
    var urgente = document.getElementById('mg-pote-urgente');
    var cta = document.getElementById('mg-pote-cta');
    var m = metricasPote();

    if (!temPedido) return;

    if (!poteAtivo) {
      renderizarMedidor(totalGummies || Number(raiz.getAttribute('data-por-pote')) || 0, totalGummies || Number(raiz.getAttribute('data-por-pote')) || 0, Math.floor((totalGummies || 60) / DOSES_DIA), false, true);
      if (urgente) {
        urgente.textContent = '📦 Pedido em preparação. A contagem começa quando o pote chegar.';
        urgente.hidden = false;
      }
      if (cta) cta.classList.remove('mg-btn--destaque');
      return;
    }

    if (hojeIso() < inicioContagem) {
      renderizarMedidor(totalGummies, totalGummies, Math.floor(totalGummies / DOSES_DIA), false, true);
      if (urgente) {
        urgente.textContent = '📦 Pedido a caminho. A contagem começa quando o pote chegar.';
        urgente.hidden = false;
      }
      if (cta) cta.classList.remove('mg-btn--destaque');
      return;
    }

    var avisoRepor = m.restantes > 0 && m.diasRestantes <= 7;
    renderizarMedidor(totalGummies, m.restantes, m.diasRestantes, false, false);
    if (urgente) {
      urgente.textContent = '⚠️ Seu pote está acabando. Hora de repor.';
      urgente.hidden = !avisoRepor;
    }
    if (cta) cta.classList.toggle('mg-btn--destaque', avisoRepor);
  }

  function renderizarMedidor(total, restam, diasRitual, semPedidoAinda, aguardandoEnvio) {
    var elRestam = document.getElementById('mg-restam');
    if (elRestam) elRestam.textContent = restam;
    var texto = document.getElementById('mg-medidor-texto');
    if (texto) {
      if (semPedidoAinda) {
        texto.innerHTML = 'Você ainda não tem nenhum pedido registrado. Faça o primeiro pra começar a contagem do seu pote.';
      } else if (aguardandoEnvio) {
        texto.innerHTML = 'Seu pedido já está com a gente. O medidor passa a contar um ritual por dia assim que o pote chegar.';
      } else if (restam > 0) {
        texto.innerHTML = 'Restam cerca de <strong>' + restam + ' de ' + total + ' gummies</strong>, uns <strong>' + diasRitual + ' dias</strong> de ritual.';
      } else {
        texto.innerHTML = 'Seu pote provavelmente já acabou. Hora de repor?';
      }
    }
    var nivel = document.getElementById('mg-nivel');
    if (!nivel) return;
    var pct = total ? Math.min(100, restam / total * 100) : 0;
    if (semMovimento) { nivel.style.height = pct + '%'; return; }
    requestAnimationFrame(function () { setTimeout(function () { nivel.style.height = pct + '%'; }, 250); });
  }

  /* reveal */
  var blocos = raiz.querySelectorAll('.mg-reveal');
  if (semMovimento || !('IntersectionObserver' in window)) {
    blocos.forEach(function (b) { b.classList.add('mg-visivel'); });
  } else {
    var obs = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mg-visivel'); obs.unobserve(e.target); } });
    }, { threshold: 0.12 });
    blocos.forEach(function (b, i) { b.style.transitionDelay = (i * 70) + 'ms'; obs.observe(b); });
  }

  /* nav — item ativo segue a seção visível (desktop + mobile) */
  var itensNav = raiz.querySelectorAll('.mg-lateral__item[data-mg-nav]');
  var marcos = raiz.querySelectorAll('[data-mg-marco]');
  var navTick = null;
  var navLockAte = 0;
  var navAtivo = '';
  var navMovel = window.matchMedia('(max-width: 1023px)');
  var barraNav = raiz.querySelector('.mg-lateral');
  var colNav = raiz.querySelector('.mg-nav-col');

  function atualizarAlturaNavFixa() {
    if (!barraNav || !navMovel.matches) return;
    var h = Math.ceil(barraNav.getBoundingClientRect().height);
    raiz.style.setProperty('--mg-nav-altura', h + 'px');
  }

  function posicionarNavDesktop() {
    if (!barraNav) return;
    if (navMovel.matches) {
      barraNav.style.left = '';
      barraNav.style.width = '';
      return;
    }
    if (!colNav) return;
    var rect = colNav.getBoundingClientRect();
    barraNav.style.left = Math.round(rect.left) + 'px';
    barraNav.style.width = Math.round(rect.width) + 'px';
  }

  function alturaBarraNav() {
    if (!barraNav) return 96;
    if (navMovel.matches) {
      var css = parseFloat(getComputedStyle(raiz).getPropertyValue('--mg-nav-altura'));
      if (!isNaN(css) && css > 0) return css + 8;
    }
    return 72;
  }

  function rolarMenuParaItem(link) {
    var ul = link.closest('.mg-lateral ul');
    if (!ul || !navMovel.matches) return;

    var linkRect = link.getBoundingClientRect();
    var ulRect = ul.getBoundingClientRect();
    var centroLink = linkRect.left + linkRect.width / 2;
    var centroUl = ulRect.left + ulRect.width / 2;
    var destino = ul.scrollLeft + (centroLink - centroUl);
    destino = Math.max(0, Math.min(destino, ul.scrollWidth - ul.clientWidth));
    if (Math.abs(destino - ul.scrollLeft) < 2) return;

    if (semMovimento || typeof ul.scrollTo !== 'function') {
      ul.scrollLeft = destino;
      return;
    }
    ul.scrollTo({ left: destino, behavior: 'smooth' });
  }

  function definirNavAtivo(chave, rolarMenu) {
    if (!chave) return;
    var mudou = chave !== navAtivo;
    navAtivo = chave;
    var linkAtivo = null;
    itensNav.forEach(function (a) {
      var ativo = a.getAttribute('data-mg-nav') === chave;
      a.classList.toggle('mg-lateral__item--ativo', ativo);
      if (ativo) {
        linkAtivo = a;
        a.setAttribute('aria-current', 'page');
      } else {
        a.removeAttribute('aria-current');
      }
    });
    if (rolarMenu && mudou && linkAtivo) {
      requestAnimationFrame(function () {
        rolarMenuParaItem(linkAtivo);
      });
    }
  }

  var ordemNav = ['ritual', 'pote', 'pedidos', 'dados'];

  function topoDocumento(el) {
    return el.getBoundingClientRect().top + window.scrollY;
  }

  function chavePorScroll() {
    if (!marcos.length) return 'ritual';

    var docEl = document.documentElement;
    var limiteFim = 40;
    if (window.scrollY + window.innerHeight >= docEl.scrollHeight - limiteFim) {
      return ordemNav[ordemNav.length - 1];
    }

    var scrollPos = window.scrollY + alturaBarraNav() + 56;
    var ativo = ordemNav[0];

    ordemNav.forEach(function (chave) {
      var el = document.getElementById('mg-' + chave);
      if (!el || !raiz.contains(el)) return;
      if (topoDocumento(el) <= scrollPos) ativo = chave;
    });

    return ativo;
  }

  function sincronizarNav() {
    if (Date.now() < navLockAte) return;
    definirNavAtivo(chavePorScroll(), true);
  }

  function agendarNav() {
    if (navTick) return;
    navTick = requestAnimationFrame(function () {
      navTick = null;
      sincronizarNav();
    });
  }

  itensNav.forEach(function (a) {
    a.addEventListener('click', function () {
      navLockAte = Date.now() + 900;
      definirNavAtivo(a.getAttribute('data-mg-nav'), true);
    });
  });

  function aoRedimensionarNav() {
    atualizarAlturaNavFixa();
    posicionarNavDesktop();
    agendarNav();
  }

  window.addEventListener('scroll', function () {
    posicionarNavDesktop();
    agendarNav();
  }, { passive: true });
  window.addEventListener('resize', aoRedimensionarNav);
  window.addEventListener('hashchange', agendarNav);
  if (navMovel.addEventListener) {
    navMovel.addEventListener('change', aoRedimensionarNav);
  }

  if (barraNav && itensNav.length) {
    atualizarAlturaNavFixa();
    posicionarNavDesktop();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        atualizarAlturaNavFixa();
        posicionarNavDesktop();
      });
    }
    requestAnimationFrame(function () {
      atualizarAlturaNavFixa();
      posicionarNavDesktop();
    });
  }

  if (location.hash) {
    var alvoHash = document.getElementById(location.hash.slice(1));
    if (alvoHash && alvoHash.hasAttribute('data-mg-marco')) {
      definirNavAtivo(alvoHash.getAttribute('data-mg-marco'), true);
    }
  }
  sincronizarNav();

  pintarRitual();
  pintarCalendario();
  pintarPote();
})();
